import { FileResponse } from '@/core/collections/files/file-response.interface';
import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { FileRequest } from './file-request.interface';
export class FileService {
   async getFiles() {
      throw Error('Method not implemented');
   }

   async getFile() {
      throw Error('Method not implemented');
   }

   async postFile(file: Partial<FileRequest>) {
      const formData = new FormData();

      // Append the file to FormData
      if (file.file && file.file instanceof File) {
         formData.append('file', file.file);
      }

      // Append other fields to FormData
      if (file.fileable_type) formData.append('fileable_type', file.fileable_type);
      if (file.fileable_id) formData.append('fileable_id', file.fileable_id.toString());
      if (file.file_type_id) formData.append('file_type_id', file.file_type_id.toString());
      if (file.file_name) formData.append('file_name', file.file_name);
      if (file.valid_till) formData.append('valid_till', file.valid_till);

      const response = await http.post<ApiResource<FileResponse>>(`/files`, formData);
      return response.data;
   }

   async putFile() {
      throw Error('Method not implemented');
   }

   async deleteFile(id: number) {
      await http.delete(`/files/${id}`);
   }

   async getNewFileUrl(id: number) {
      const response = await http.get<ApiResource<FileResponse>>(`/files/${id}`);
      return response.data;
   }

   async getExternalFileUrl(id: number) {
      const response = await http.get<{ url: string }>(`/files/${id}/external-url`);
      return response.data;
   }
}
